import InteractionPoint from "../InteractionPoint";
import React from "react";

export default function ServiceCenterInteractions() {
  return (
    <>
      <InteractionPoint
        args={[0.15, 0.15, 0.15]}
        position={[0.494, .755, -1.5236]}
        module={"logoInteraction"}
      ></InteractionPoint>
    </>
  );
}
